// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"QV_0vG"};